import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { ThemeProvider as StylesThemeProvider } from '@mui/styles';
import theme from "./theme/theme";
import { AppDomains, getCurrentApp } from './util/AppUtil';
import tynoTheme from './theme/tynoTheme';

const appDomain = getCurrentApp();
const activeTheme = appDomain === AppDomains.EPROCESSIFY ? theme : tynoTheme;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={activeTheme}>
      <StylesThemeProvider theme={activeTheme}>
        <App />
      </StylesThemeProvider>
    </ThemeProvider>
  </StyledEngineProvider>
);
